import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle, MapPin } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6">
      <div className="text-center max-w-md" data-testid="payment-cancel-page">
        <div className="flex items-center justify-center gap-2 mb-8">
          <div className="h-8 w-8 rounded-md bg-[#0055FF] flex items-center justify-center"><MapPin weight="fill" size={18} className="text-white" /></div>
          <span className="font-display font-black text-lg tracking-tight text-slate-900">CiteHub</span>
        </div>
        <XCircle weight="fill" size={64} className="text-slate-400 mx-auto" />
        <h1 className="font-display text-2xl font-bold text-slate-900 mt-6">Checkout canceled</h1>
        <p className="text-slate-600 mt-2">No charge was made. You can activate your membership whenever you're ready.</p>
        <Button onClick={() => navigate("/subscribe")} data-testid="cancel-retry-button" className="mt-6 bg-[#0055FF] hover:bg-[#0044CC] text-white">Back to membership</Button>
      </div>
    </div>
  );
}
